<template>
  <div class="textfield">
    {{ data }}
  </div>
</template>

<script>
export default {
  name: 'tablefield-factsheet',
  props: ['data', 'config'],
}
</script>



// WEBPACK FOOTER //
// FieldFactsheet.vue?5fa556b4